// extracted by mini-css-extract-plugin
export var cardContainer = "_p7-0";
export var cardHeader = "_p7-2";
export var collapsedState = "_p7-3";
export var dragHandle = "_p7-5";
export var dragHandleIcon = "_p7-6";
export var dragging = "_p7-1";
export var titleArea = "_p7-4";